import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BonusqrService } from 'src/app/shared/servicio/bonusqr/bonusqr.service';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-bonus-qr-referrals-detail',
  templateUrl: './bonus-qr-referrals-detail.component.html',
  styleUrls: ['./bonus-qr-referrals-detail.component.css'],
})
export class BonusQrReferralsDetailComponent implements OnInit {
  code: string;
  loading = true;
  referrals: any[] = [];
  count = 0;
  page = 1;
  hasNext = false;
  hasPrevious = false;

  isAdmin = localStorage.getItem('type') === '3';

  constructor(private _route: ActivatedRoute, private _bonusqr: BonusqrService, public _helper: HelpersService) {}

  ngOnInit(): void {
    this.code = this._route.snapshot.paramMap.get('code');
    this.load();
  }

  load(): void {
    this.loading = true;
    this._bonusqr.getReferralsByCode(this.code, this.page).subscribe(
      (data: any) => {
        this.referrals = data.results || [];
        this.count = data.count || 0;
        this.hasNext = !!data.next;
        this.hasPrevious = !!data.previous;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this._helper.modalError('No se pudieron cargar los referidos de este QR');
      }
    );
  }

  nextPage(): void {
    if (!this.hasNext) {
      return;
    }
    this.page++;
    this.load();
  }

  previousPage(): void {
    if (!this.hasPrevious || this.page <= 1) {
      return;
    }
    this.page--;
    this.load();
  }
}
